import * as T from './Timer.types';
import * as C from './Timer.const';

export const calculateTimerValues = (dt: string): T.TTimerValues => {
  const countdownDate = new Date(dt).getTime();

  const now = new Date().getTime();
  const timeDifference = countdownDate - now;

  const hours = Math.floor((timeDifference % C.DAYS) / C.HOURS);
  const minutes = Math.floor((timeDifference % C.HOURS) / C.MINUTES);
  const seconds = Math.floor((timeDifference % C.MINUTES) / C.SECONDS);

  return {
    hours: hours <= 9 ? `0${hours}` : hours,
    minutes: minutes <= 9 ? `0${minutes}` : minutes,
    seconds: seconds <= 9 ? `0${seconds}` : seconds,
  };
};
